export const flattenRichTextNodes = (nodes: unknown[]) => {
  const flattened: unknown[] = [];

  for (const node of nodes) {
    // @ts-expect-error node does not contain
    if (node.content) {
      // @ts-expect-error node does not contain
      const { content, ...rest } = node;
      flattened.push(rest as Node);
      flattened.push(...flattenRichTextNodes(content as Node[]));
    } else {
      flattened.push(node);
    }
  }

  return flattened;
};

export const getOffsetTop = (element: HTMLElement | null): number => {
  if (!element) return 0;

  return element
    ? element.offsetTop +
        getOffsetTop((element?.offsetParent as HTMLElement) ?? null)
    : 0;
};
